import { Badge } from '@/components';

interface Colors {
  bg: string;
  text: string;
}

type HttpStatusRangeKey = 1 | 2 | 3 | 4 | 5;

export const httpColor: Record<HttpStatusRangeKey, Colors> = {
  5: { bg: '#FFCDD2', text: '#C62828' },
  4: { bg: '#FFCDD2', text: '#C62828' },
  3: { bg: '#E0E0E0', text: '#424242' },
  2: { bg: '#C8E6C9', text: '#2E7D32' },
  1: { bg: '#E0E0E0', text: '#424242' },
};

const getColorProps = (colors: any, value: string) => ({
  textColor: colors[value].text,
  backgroundColor: colors[value].bg,
  ballColor: colors[value].text,
});

export const renderLastRunHttpCode = (value: number) => {
  if (!value) return <></>;
  const firstDigit = String(value).at(0) ?? '1';
  const { backgroundColor, ...rest } = getColorProps(httpColor, firstDigit);
  return <Badge {...rest} value={String(value)} />;
};
